import { log } from 'log';
import { getLocationParams, redirect, serialize } from 'js/utils/url.util';

/**
 * ?htcmd=1 -- for desktop download clients
 * ?isNative=1 -- for mobile native apps
 */
export class HTCMDService {
    requestDelay = 200;
    requestPromise = Promise.resolve();

    get isEnabled() {
        const { htcmd, isNative } = getLocationParams();

        return htcmd === '1' || isNative === '1';
    }

    get isWrapperEnabled() {
        const { isWrapper } = getLocationParams();

        return isWrapper === '1';
    }

    sendMessageAsync = async (command, options) => {
        let htcmdUrl = `htcmd:${command}`;

        if (options) {
            htcmdUrl = `${htcmdUrl}?${serialize(options)}`;
        }

        log('log', htcmdUrl);

        redirect(htcmdUrl);

        await new Promise((resolve) => setTimeout(resolve, this.requestDelay));
    };

    sendMessage = (command, options) => {
        this.requestPromise = this.requestPromise.then(() => this.sendMessageAsync(command, options));
    };

    register = (options) => {
        this.sendMessage('login', options);
    };

    login = (options) => {
        const { isNative, isWrapper } = getLocationParams();

        if (isNative) {
            Object.assign(options, { allowedMethods: 'Touch' });
        }

        this.sendMessage(isNative || isWrapper ? 'loginsuccess' : 'login', options);
    };

    openLogin = () => {
        this.sendMessage('openLogin');
    };

    openDeposit = () => {
        this.sendMessage('openDeposit');
    };

    registerNative = (options) => {
        Object.assign(options, { allowedMethods: 'Touch' });

        this.sendMessage('registersuccess', options);
    };

    processBiometricAuthentication = () => {
        this.sendMessage('authentication/processBiometricAuthentication');
    };

    enableBiometrics = (options) => {
        this.sendMessage('authentication/enableBiometrics', options);
    };

    isBiometricsEnabled = (isEnabled) => {
        this.sendMessage('authentication/biometricsEnabled', { success: isEnabled });
    };

    userConsent = (allowToTrack) => {
        this.sendMessage('userConsent', { allowToTrack: allowToTrack ? '1' : '0' });
    };

    portalReady = (options) => {
        this.sendMessage('portalReady', options);
    };

    portalEvent = (options) => {
        this.sendMessage('portalEvent', options);
    };

    reset = () => {
        this.sendMessage('authentication/reset');
    };

    logout = (isManual) => {
        this.sendMessage('logout', {
            type: isManual ? 'manual' : 'automatic'
        });
    };

    /**
     * Open chrome custom tab / Safari View Controller within native
     */
    openCustomTab = (path) => {
        this.sendMessage('openCustomTab', { path });
    };

    /**
     * Used in CaptchaPage for Native app
     */
    successCaptcha = () => {
        this.sendMessage('successCaptcha');
    };

    /**
     * Used in CaptchaPage for Native app
     */
    failedCaptcha = () => {
        this.sendMessage('failedCaptcha');
    };

    /**
     * Used in initiate download in Native / Wrapper app
     */
    download = (url, name, mime) => {
        return this.sendMessage('download', { url, name, mime });
    };

    /**
     * Used to launch the game inside Native app
     */
    launchgame = ({ code, bingoGameType = '', ...rest }) => {
        const options = { gamecode: code, ...rest };

        if (bingoGameType?.length) {
            options.bingoroom = bingoGameType;
        }

        this.sendMessage('launchgame', options);
    };

    /**
     * Open webView overlay with native context
     */
    openExternalPage = (url) => {
        this.sendMessage('goToExternalPage', { url: encodeURIComponent(url) });
    };
}

export const htcmdService = new HTCMDService();
